/**
 * Shared by the SSR (ssr/islands/load-island.mjs) and client (public/js/islands/load-island.js)
 * island loaders. Accepts function/class components and React element types that are objects with a
 * `$$typeof` symbol (memo, forwardRef, lazy, context), which a plain `typeof === 'function'` rejects.
 * @param {unknown} value
 * @returns {boolean}
 */
export function isValidComponent(value) {
  if (typeof value === 'function') {
    return true;
  }

  return typeof value === 'object' && value !== null && '$$typeof' in value;
}
